/*
 * Conversões da área B2B no Meta Pixel.
 *
 * O pixel base já é inicializado no layout/theme.liquid; aqui só entram os
 * eventos. Existe um arquivo separado para isso por dois motivos:
 *
 *   1. O ID do pixel fica num lugar só. Ele também aparece no theme.liquid, e
 *      espalhá-lo por cada formulário garantiria que um dia ficassem diferentes.
 *   2. Os botões de WhatsApp são renderizados de cinco pontos distintos. Um
 *      listener delegado no documento cobre todos, inclusive os que forem
 *      adicionados depois.
 *
 * Padrão herdado da LP do Café com Yuri (nexusclub): o evento dispara no
 * SUCESSO REAL do envio, dentro do .then() depois do res.ok — nunca no clique
 * do botão. Esses formulários enviam por fetch e mostram o sucesso na própria
 * página: não há troca de URL para o GTM acionar, e disparar no clique contaria
 * cadastro que falhou na validação ou na rede.
 */
(function () {
  'use strict';

  /* Carregado pelo ec-b2b-header, que renderiza uma vez por página. A trava
     existe mesmo assim: foi exatamente esse descuido que fez o cadastro de
     representante gravar em triplicata. */
  if (window.sdnB2bTrack) return;

  // Mesmo pixel do layout/theme.liquid. Se mudar lá, muda aqui.
  var PIXEL = '1743375479244890';

  /* trackSingle, e não track: o tema carrega dois contêineres GTM além deste
     pixel, e apps instalam os seus. `track` dispararia em todos eles. */
  function enviar(evento, dados) {
    // Bloqueador de anúncio não pode derrubar o formulário junto.
    if (typeof window.fbq !== 'function') return;
    try {
      window.fbq('trackSingle', PIXEL, evento, dados || {});
    } catch (erro) {
      console.error('[sdn-b2b-track]', erro);
    }
  }

  window.sdnB2bTrack = enviar;

  /* Entrada na área B2B — o topo do funil.
     Disparado na CHEGADA da página, não no clique que leva até ela: um clique
     que navega concorre com o unload e parte dos envios se perde. Aqui é 100%
     dos que realmente chegaram.
     window.sdnB2bPagina vem do ec-b2b-header e diz QUAL página é, para separar
     a LP de revendedores da PDP e da página de representante. */
  enviar('ViewContent', {
    content_name: 'B2B — ' + (window.sdnB2bPagina || 'area'),
    content_category: window.sdnB2bPagina || 'b2b'
  });

  /* Cliques nos botões de WhatsApp. O atributo data-b2b-origem é o que responde
     "onde ele acessou": o mesmo botão aparece no topo, no header, no CTA da LP,
     no rodapé e na PDP, e sem rótulo tudo chegaria misturado. */
  document.addEventListener('click', function (evento) {
    var alvo = evento.target.closest ? evento.target.closest('[data-b2b-wa]') : null;
    if (!alvo) return;
    enviar('Contact', {
      content_name: alvo.getAttribute('data-b2b-consultor') || 'Consultor B2B',
      content_category: alvo.getAttribute('data-b2b-origem') || 'b2b'
    });
  });
})();
